var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[(!_vm.hideHeader)?_c('Header'):_vm._e(),_c('div',{class:{ main: true, hideHeader: _vm.hideHeader }},[_c('Sidebar'),_c('div',{staticClass:"content"},[_c('router-view',{staticClass:"content-wrapper"})],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }